import { render } from "./ContactDetailsForm.vue?vue&type=template&id=3a641175&scoped=true"
import script from "./ContactDetailsForm.vue?vue&type=script&lang=js"
export * from "./ContactDetailsForm.vue?vue&type=script&lang=js"

import "./ContactDetailsForm.vue?vue&type=style&index=0&id=3a641175&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a641175"]])

export default __exports__